// CModal.jsx - Updated with more aggressive padding fix
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  AppBar,
  Toolbar,
  Button
} from "@mui/material";

/**
 * CModal - Customizable modal dialog component with sticky header
 */
const CModal = ({
  open,
  handleClose,
  title,
  children,
  actions = [],
  maxWidth = "md",
  fullWidth = true,
  width,
  headerBgColor = "#002A5B"
}) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}} // Prevents default closing behavior
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      disableEscapeKeyDown={true}
      PaperProps={{
        style: {
          borderRadius: "8px",
          overflow: "hidden",
          width: width || undefined,
          maxWidth: width ? "none" : undefined
        }
      }}
      BackdropProps={{
        onClick: (e) => e.stopPropagation()
      }}
    >
      {/* Sticky Header */}
      <AppBar 
        position="sticky" 
        color="primary" 
        elevation={0}
        sx={{ 
          backgroundColor: headerBgColor,
          zIndex: 1100
        }}
      >
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1, color: "white" }}>
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      
      {/* Content with aggressive padding override */}
      <DialogContent 
        dividers
        sx={{ 
          padding: "16px 16px !important", // Use !important to override any default styles
          "&.MuiDialogContent-root": {
            padding: "16px 16px !important",  // Equal padding but reduced from standard
          },
          "& > *": {  // Apply styles to direct children of DialogContent
            paddingLeft: 0,
            paddingRight: 0,
            marginLeft: 0,
            marginRight: "-5px",
          }
        }}
      >
        {children}
      </DialogContent>
      
      {/* Actions */}
      {actions && actions.length > 0 && (
        <DialogActions>
          {actions.map((action, index) => (
            <Button 
              key={index}
              onClick={action.onClick}
              color={action.color || "primary"}
              variant={action.variant || "contained"}
              startIcon={action.startIcon}
              endIcon={action.endIcon}
              size={action.size || "medium"}
              sx={{ ml: index > 0 ? 1 : 0, ...(action.sx || {}) }}
            >
              {action.label}
            </Button>
          ))}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CModal;